import React, { useEffect } from "react";
import { observer } from "mobx-react";
import { useDevice, useScreenDimensions } from "../../_layout";
import exerciseHistoryStore, {
  closeExerciseHistory,
} from "./ExerciseHistoryStore";
import ExerciseHistoryFloating from "./ExerciseHistoryFloating";
import ExerciseHistoryModal from "./ExerciseHistoryModal";

const GlobalExerciseHistoryFloating = observer(() => {
  const { isMobile } = useDevice();
  const { screenSize } = useScreenDimensions();
  const isOpen = exerciseHistoryStore.isOpen;
  const exercise = exerciseHistoryStore.exercise;
  const client = exerciseHistoryStore.client;
  const anchorEl = exerciseHistoryStore.anchorEl;

  useEffect(() => {
    return () => {
      exerciseHistoryStore.reset();
    };
  }, []);

  if (!isOpen || !exercise) return null;

  if (isMobile && screenSize === "small") {
    return (
      <ExerciseHistoryModal
        isVisible={isOpen}
        exercise={exercise}
        client={client}
        onClose={closeExerciseHistory}
      />
    );
  }

  return (
    <ExerciseHistoryFloating
      isVisible={isOpen}
      exercise={exercise}
      client={client}
      onClose={closeExerciseHistory}
      panelWidth={320}
      anchorEl={anchorEl}
    />
  );
});

export default GlobalExerciseHistoryFloating;
